import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c(VCol,{attrs:{"lg":"2","xl":"2"}},[_c(VCard,{staticClass:"ad-card-collapsed pa-3",attrs:{"elevation":"0"},on:{"click":_vm.openUrl}},[_c(VCardTitle,{staticClass:"justify-end mt-n7 mb-n3"},[_c('div',{staticClass:"badge"},[_vm._v("AD")])]),_c(VCardText,[_c('h3',{staticClass:"ad-title"},[_vm._v(_vm._s(_vm.ad.title))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }